import { useMutation } from "@apollo/client";
import { GENERATE_QUOTATION_PDF } from "../apollo/mutations";
import { useCallback, useRef } from "react";
import { downloadPDF } from "../utils/helperFunctions";

const useGeneratePDF = () => {
  const fileNameRef = useRef(""); 
  const [generatePDF, { loading, error, data }] = useMutation(
    GENERATE_QUOTATION_PDF,
    {
      onCompleted: (data) => {
        console.log("Stored fileName:", fileNameRef.current); 
        if (data?.generateOrderPDF) {
          const base64 = data.generateOrderPDF;
          downloadPDF(base64, fileNameRef.current);
        }
      },
      onError: (err) => {
        console.error("Error generating PDF:", err.message);
      },
    }
  );

  const generateQuotationPDF = useCallback(
    (quotationId, fileName) => {
      if (quotationId) {
        console.log("fileNamefileNamefileName", fileName)
        fileNameRef.current = fileName; 
        generatePDF({
          variables: { generateOrderPdfId: quotationId },
        });
      }
    },
    [generatePDF]
  );

  return {
    generateQuotationPDF, // Function to trigger PDF generation
    loading,
    error,
    data,
  };
};

export default useGeneratePDF;